import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseComponent } from './pages/base/base.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PageType } from './core/models/page-type';
import { Role } from './core/models/role';

import { AuthGuard } from './core/guards/auth.guard';
import { BreadcrumbGuard } from './core/guards/breadcrumb.guard';

const routes: Routes = [
	{
		path: '',
		component: BaseComponent,
		canActivate: [BreadcrumbGuard, AuthGuard],
		children: [
			{ path: '', pathMatch: 'full', redirectTo: 'devices' },
			{ path: 'page-not-found', component: PageNotFoundComponent, data: { roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.USER, Role.VIEWER] } },

			{
				path: 'devices', children: [
					{ path: '', loadChildren: () => import('./pages/devices/devices.module').then(m => m.DevicesModule), data: { roles: [Role.SUPER_ADMIN,Role.ADMIN, Role.USER, Role.VIEWER] }, canActivate: [BreadcrumbGuard, AuthGuard]},
					{ path: 'new', loadChildren: () => import('./pages/devices/alter/alter.module').then(m => m.AlterModule), data: { roles: [Role.SUPER_ADMIN,Role.ADMIN, Role.USER], pageType: PageType.NEW }, canActivate: [BreadcrumbGuard, AuthGuard] },
					{ path: 'edit/:uuid', loadChildren: () => import('./pages/devices/alter/alter.module').then(m => m.AlterModule), data: { roles: [Role.SUPER_ADMIN,Role.ADMIN, Role.USER, Role.VIEWER], pageType: PageType.EDIT }, canActivate: [BreadcrumbGuard, AuthGuard] },
				]
			},
			{
				path: 'monitoring', children: [
					{ path: '', loadChildren: () => import('./pages/monitoring/monitoring.module').then(m => m.MonitoringModule), data: { roles: [Role.SUPER_ADMIN,Role.ADMIN, Role.USER, Role.VIEWER]}, canActivate: [BreadcrumbGuard, AuthGuard] },
					{ path: ':uuid', loadChildren: () => import('./pages/monitoring/details/details.module').then(m => m.DetailsModule), data: { roles: [Role.SUPER_ADMIN,Role.ADMIN, Role.USER, Role.VIEWER]}, canActivate: [BreadcrumbGuard, AuthGuard] },
				]
			},
			{
				path: 'users', children: [
					{ path: '', loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule), data: { roles: [Role.SUPER_ADMIN,Role.ADMIN]}, canActivate: [BreadcrumbGuard, AuthGuard] },
					{ path: 'new', loadChildren: () => import('./pages/users/alter/alter.module').then(m => m.AlterModule), data: { roles: [Role.SUPER_ADMIN,Role.ADMIN], pageType: PageType.NEW }, canActivate: [BreadcrumbGuard, AuthGuard]},
					{ path: 'edit/:uuid', loadChildren: () => import('./pages/users/alter/alter.module').then(m => m.AlterModule), data: { roles: [Role.SUPER_ADMIN,Role.ADMIN], pageType: PageType.EDIT }, canActivate: [BreadcrumbGuard, AuthGuard]},
				]
			},
			{
				path: 'vpn', children: [
					{ path: '', loadChildren: () => import('./pages/vpn/vpn.module').then(m => m.VpnModule), data: { roles: [Role.SUPER_ADMIN] }, canActivate: [BreadcrumbGuard, AuthGuard]},
					{ path: 'new', loadChildren: () => import('./pages/vpn/alter/alter.module').then(m => m.AlterModule), data: { roles: [Role.SUPER_ADMIN], pageType: PageType.NEW }, canActivate: [BreadcrumbGuard, AuthGuard]},
					{ path: 'edit/:uuid', loadChildren: () => import('./pages/vpn/alter/alter.module').then(m => m.AlterModule), data: { roles: [Role.SUPER_ADMIN], pageType: PageType.EDIT }, canActivate: [BreadcrumbGuard, AuthGuard]},
				]
			},

			{ path: '**', pathMatch: 'full', redirectTo: 'page-not-found' }
		]
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
